import { render, staticRenderFns } from "./questionTypeRange.vue?vue&type=template&id=53507610&scoped=true&"
import script from "./questionTypeRange.vue?vue&type=script&lang=js&"
export * from "./questionTypeRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53507610",
  null
  
)

export default component.exports